const apiPath = 'https://vpznmhj9q9.execute-api.ap-northeast-1.amazonaws.com/api';
export default {
  apiPath,
  Auth: {
    identityPoolId: 'ap-northeast-1:31730a79-618a-4a9f-ac9c-e35b87c1942c',
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_1p02IeXXD',
    userPoolWebClientId: '2e0ot2lklm7ovapuumt05iks38',
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: apiPath + '/pub',
        region: 'ap-northeast-1',
      },
    ],
  },
};
